// removed by extract-text-webpack-plugin
module.exports = {"defaultClass":"styles__defaultClass___7Ay1_","primary":"styles__primary___2CNCj","div_flex":"styles__div_flex___2qvZL","icon":"styles__icon___2fHx_","secondaryOutline":"styles__secondaryOutline___2oysJ","linkBackground":"styles__linkBackground___2alxA","disabledLink":"styles__disabledLink___1UmsA","secondary":"styles__secondary___2L0rW"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/ButtonFixedVoice/styles.css
// module id = 3143
// module chunks = 0